// => Capitalize first char
export const strCapitalizeFirstChar = (string) => {
    let capitalizedStr = string.charAt(0).toUpperCase() + string.substring(1);
    return capitalizedStr;
};
